import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8b2edbae"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "d-flex flex-column flex-lg-row flex-column-fluid",
  id: "login-container"
}
const _hoisted_2 = {
  class: "d-flex flex-column flex-lg-row-fluid flex-lg-row-auto py-10 w-50-p",
  style: {"background":"#fff"}
}
const _hoisted_3 = { class: "d-flex flex-center flex-column flex-column-fluid" }
const _hoisted_4 = { class: "w-lg-500px p-10 p-lg-15 mx-auto login-form-container" }
const _hoisted_5 = {
  key: 0,
  class: "alert alert-warning d-flex align-items-center p-5 w-80"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-20 text-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-exclamation fs-2hx text-warning me-4" })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "mb-1 text-warning" }, "Referral Code Does Not Exist"),
  /*#__PURE__*/_createElementVNode("span", null, "The referral does not next in our database. But you can still sign up and join our membership rewards.")
], -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3 text-sign-in" }, "Welcome to BluePerks!"),
  /*#__PURE__*/_createElementVNode("div", { class: "fs-5 subtext-sign-in" }, " Create an account and join our membership rewards. ")
], -1))
const _hoisted_10 = {
  class: "fs-4 subtext-sign-in text-center",
  style: {"margin-top":"34px"}
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Already have an account? ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Sign In")
const _hoisted_13 = { class: "login-links" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("About")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Support")
const _hoisted_16 = {
  class: "d-flex w-50-p aside justify-content-center align-items-center",
  style: {"background-color":"#1a4db4"}
}
const _hoisted_17 = { class: "d-flex flex-column justify-content-center align-items-center pt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainLogo = _resolveComponent("MainLogo")!
  const _component_SignUpForm = _resolveComponent("SignUpForm")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_MainLogo, { class: "logo-app-mobile m-auto" }),
        _createElementVNode("div", _hoisted_4, [
          (!_ctx.isValid)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
            : _createCommentVNode("", true),
          _hoisted_9,
          _createVNode(_component_SignUpForm, { referral: _ctx.referralCode }, null, 8, ["referral"]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_router_link, {
              to: "/sign-in",
              class: "text-link"
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_router_link, {
              to: "/sign-up",
              class: "link",
              style: {"margin-right":"40px"}
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/sign-up",
              class: "link"
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_MainLogo, { class: "logo" })
      ])
    ])
  ]))
}